var _defs, _g, _rect, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 611.5 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ed1c24;\n      }\n\n      .cls-3 {\n        fill: #b0b0b0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m370.8,23.49h20.69v2.94h-17.46v9.77h15.62v2.94h-15.62v10.02h17.67v2.94h-20.9v-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m398,23.49h9.94c9,0,15.21,6.18,15.21,14.23v.08c0,8.06-6.22,14.31-15.21,14.31h-9.94v-28.63Zm9.94,25.64c7.24,0,11.86-4.91,11.86-11.25v-.08c0-6.34-4.62-11.33-11.86-11.33h-6.71v22.66h6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m429.32,40.13v-16.64h3.23v16.44c0,6.18,3.27,9.65,8.75,9.65s8.63-3.19,8.63-9.45v-16.64h3.23v16.4c0,8.34-4.78,12.68-11.94,12.68s-11.9-4.34-11.9-12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m459.34,37.88v-.08c0-8.1,6.05-14.8,14.48-14.8,5.19,0,8.3,1.84,11.16,4.54l-2.21,2.37c-2.41-2.29-5.11-3.93-9-3.93-6.34,0-11.08,5.15-11.08,11.74v.08c0,6.63,4.78,11.82,11.08,11.82,3.93,0,6.5-1.51,9.24-4.13l2.13,2.09c-2.99,3.03-6.26,5.03-11.45,5.03-8.26,0-14.35-6.5-14.35-14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m501.18,23.28h3.03l13.05,28.83h-3.48l-3.35-7.57h-15.58l-3.39,7.57h-3.31l13.05-28.83Zm7.97,18.36l-6.5-14.6-6.54,14.6h13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m528.99,57.06l3.15-4.58c-7.24-.94-12.39-7.03-12.39-14.6v-.08c0-8.1,6.05-14.8,14.48-14.8,5.19,0,8.3,1.84,11.16,4.54l-2.21,2.37c-2.41-2.29-5.11-3.93-9-3.93-6.34,0-11.08,5.15-11.08,11.74v.08c0,6.63,4.78,11.82,11.08,11.82,3.93,0,6.5-1.51,9.24-4.13l2.13,2.09c-2.86,2.9-5.97,4.83-10.8,4.99l-2.7,5.89-3.07-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m561.58,23.28h3.03l13.05,28.83h-3.48l-3.35-7.57h-15.58l-3.39,7.57h-3.31l13.05-28.83Zm-5.11-2.94c.82-2.82,1.92-4.17,3.84-4.17,1.8,0,4.13,1.59,5.48,1.59,1.06,0,1.51-.57,2.13-1.92l2,.57c-.82,2.82-1.92,4.13-3.84,4.13-1.8,0-4.13-1.59-5.48-1.59-1.06,0-1.51.57-2.13,1.96l-2-.57Zm13.09,21.31l-6.5-14.6-6.54,14.6h13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m580.15,37.88v-.08c0-7.89,5.93-14.8,14.64-14.8s14.56,6.83,14.56,14.72v.08c0,7.89-5.93,14.8-14.64,14.8s-14.56-6.83-14.56-14.72Zm25.85,0v-.08c0-6.5-4.74-11.82-11.29-11.82s-11.21,5.23-11.21,11.74v.08c0,6.5,4.74,11.82,11.29,11.82s11.21-5.23,11.21-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m369.53,80.44v-.08c0-7.89,5.93-14.8,14.64-14.8s14.56,6.83,14.56,14.72v.08c0,7.89-5.93,14.8-14.64,14.8s-14.56-6.83-14.56-14.72Zm25.85,0v-.08c0-6.5-4.74-11.82-11.29-11.82s-11.21,5.23-11.21,11.74v.08c0,6.5,4.74,11.82,11.29,11.82s11.21-5.23,11.21-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m405.36,66.04h3.03l18.04,22.94v-22.94h3.15v28.63h-2.58l-18.49-23.47v23.47h-3.15v-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m437.46,66.04h3.23v25.64h16.11v2.99h-19.34v-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m462.86,66.04h3.23v28.63h-3.23v-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m474.27,66.04h3.03l18.04,22.94v-22.94h3.15v28.63h-2.58l-18.49-23.47v23.47h-3.15v-28.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m506.37,66.04h20.69v2.94h-17.46v9.77h15.62v2.94h-15.62v10.02h17.67v2.94h-20.9v-28.63Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 345.06,
    y: 1.37,
    width: 1.67,
    height: 108.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 19.22,
    width: 323,
    height: 81.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.94,48c3.03-14.48-5.89-18.18-22.22-18.01-13.8,0-26.09,7.07-26.93,21.38-.67,10.94,11.61,12.46,20.03,14.81,3.03.84,8.92,2.69,8.58,6.73-.34,4.21-6.4,6.23-9.59,6.4-5.72.34-9.59-2.69-8.42-8.08h-16.83l-.17,1.35c-1.01,16.83,11.61,18.35,23.4,18.35,6.56,0,12.29-1.51,15.99-3.37,3.53-1.85,7.07-4.38,9.09-7.24,3.87-5.22,5.55-13.63,2.02-19.02-3.7-5.55-12.29-5.89-18.35-8.25-2.02-.67-9.59-1.35-7.91-6.56,2.86-8.42,17.17-6.56,14.81,1.68l16.5-.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 30.66,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 53.55,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 42.11,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.5 42.44 137.68 31 93.08 31 80.79 89.41 125.9 89.41 128.76 78.13 99.98 78.13 102.34 65.84 128.76 65.84 131.29 54.06 104.86 54.06 106.71 42.44 135.5 42.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "287.32 89.41 299.77 31 283.11 31 270.65 89.41 287.32 89.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m221.17,78.3h23.4l1.68,11.11h18.51l-11.11-58.41h-20.03l-35.51,58.41h16.83l6.23-11.11Zm19.36-36.02h.17l2.69,24.41h-15.65l12.79-24.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 65,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "159.23 44.97 159.4 44.97 169.5 89.41 191.88 89.41 204.67 30.83 189.69 30.83 180.77 73.25 180.6 73.25 170.17 30.83 147.28 30.83 134.99 89.41 149.47 89.41 159.23 44.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 88.06,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 42.11,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 53.55,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 30.66,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 65,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 76.61,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 88.06,
    width: 17.17,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.83,
    y: 76.61,
    width: 17.17,
    height: 1.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEad);
export default __webpack_public_path__ + "static/media/logo-ead.5ace4b2b4a76fa871bb007f891487f4a.svg";
export { ForwardRef as ReactComponent };